import { Text } from '@telegram-apps/telegram-ui';
import type { CSSProperties, TextareaHTMLAttributes } from 'react';
import { forwardRef } from 'react';
import styled from 'styled-components';

const typographyStyle: any = {
    display: 'block',
    width: '100%',
    margin: '0',
    border: '0',
    outline: '0',
    padding: '0',
    resize: 'none',
    background: 'transparent',
    boxSizing: 'border-box',
    color: 'var(--tgui--text_color)',
    '&::placeholder': {
        color: 'var(--tgui--secondary_hint_color)',
        opacity: 1,
    }
};

const StyledTextTypography = styled(Text)(typographyStyle);

const CustomFormTextarea = styled.div({
    position: 'relative',
    background: 'transparent',
    minHeight: '48px'
});

export type CustomTextareaProps = Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'ref'> & {
    wrapperStyle?: CSSProperties;
};

export const CustomTextarea = forwardRef<HTMLTextAreaElement, CustomTextareaProps>(({
    wrapperStyle,
    style,
    ...restProps
}, ref) => {
    return (
        <CustomFormTextarea style={wrapperStyle}>
            <StyledTextTypography
                ref={ref}
                Component="textarea"
                style={style}
                {...restProps}
            />
        </CustomFormTextarea>
    );
});
